import { io } from "socket.io-client";
import { BASE_URL } from "./environment";

export const socket = io(BASE_URL);
